import * as React from "react";
const SvgIcKeyboardOption = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.5 3.333h5.092L13.458 15H17.5v1.667h-5.1L6.533 5H2.5V3.333Zm9.167 0H17.5V5h-5.833V3.333Z" /></svg>;
export default SvgIcKeyboardOption;